import React from "react";

function Booking() {
  return (
    <div>
      <section className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">Rezervasyon</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Ana Sayfa</a>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    Rezervasyon
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="container-xxl py-5">
        <div className="container">
          <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">Süreç</h6>
            <h1 className="mb-5">3 Kolay Adım</h1>
          </div>
          <div className="row gy-5 gx-4 justify-content-center">
            <div className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp" data-wow-delay="0.1s">
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow" style={{ width: 100, height: 100 }}>
                  <i className="fa fa-globe fa-3x text-white" />
                </div>
                <h5 className="mt-4">Bir Destinasyon Seçin</h5>
                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />
                <p className="mb-0">Geçici olarak elitr rebum clita dolor diam ipsum sit diam amet diam eos erat ipsum et lorem et sit sed stet lorem sit</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp" data-wow-delay="0.3s">
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow" style={{ width: 100, height: 100 }}>
                  <i className="fa fa-dollar-sign fa-3x text-white" />
                </div>
                <h5 className="mt-4">Çevrimiçi Ödeme Yapın</h5>
                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />
                <p className="mb-0">Geçici olarak elitr rebum clita dolor diam ipsum sit diam amet diam eos erat ipsum et lorem et sit sed stet lorem sit</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp" data-wow-delay="0.5s">
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow" style={{ width: 100, height: 100 }}>
                  <i className="fa fa-plane fa-3x text-white" />
                </div>
                <h5 className="mt-4">Bugün Uçun</h5>
                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />
                <p className="mb-0">Geçici olarak elitr rebum clita dolor diam ipsum sit diam amet diam eos erat ipsum et lorem et sit sed stet lorem sit</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="booking p-5">
            <div className="row g-5 align-items-center">
              <div className="col-md-6 text-white">
                <h6 className="text-white text-uppercase">Rezervasyon</h6>
                <h1 className="text-white mb-4">Çevrimiçi Rezervasyon</h1>
                <p className="mb-4">Geçici olarak elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit.</p>
                <p className="mb-4">Geçici olarak elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                <a className="btn btn-outline-light py-3 px-5 mt-2" href="">
                  Daha Fazla Oku
                </a>
              </div>
              <div className="col-md-6">
                <h1 className="text-white mb-4">Bir Tur Rezervasyonu Yapın</h1>
                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input type="text" className="form-control bg-transparent" id="name" placeholder="Adınız" />
                        <label htmlFor="name">Adınız</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input type="email" className="form-control bg-transparent" id="email" placeholder="E-posta Adresiniz" />
                        <label htmlFor="email">E-posta Adresiniz</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating date" id="date3" data-target-input="nearest">
                        <input type="text" className="form-control bg-transparent datetimepicker-input" id="datetime" placeholder="Tarih ve Saat" data-target="#date3" data-toggle="datetimepicker" />
                        <label htmlFor="datetime">Tarih ve Saat</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <select className="form-select bg-transparent" id="select1">
                          <option value={1}>Hedef 1</option>
                          <option value={2}>Hedef 2</option>
                          <option value={3}>Hedef 3</option>
                        </select>
                        <label htmlFor="select1">Hedef</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea className="form-control bg-transparent" placeholder="Özel İstek" id="message" style={{ height: 100 }} defaultValue={""} />
                        <label htmlFor="message">Özel İstek</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button className="btn btn-outline-light w-100 py-3" type="submit">
                        Şimdi Rezervasyon Yap
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Booking;
